document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
    gsap.registerPlugin(ScrollTrigger, SplitText);

    gsap.utils.toArray(".slide-up").forEach((element) => {
      gsap.fromTo(
        element,
        {
          y: 50,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          duration: 1.3,
          ease: "power3.out",
          scrollTrigger: {
            trigger: element,
            start: "top 85%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    gsap.utils.toArray(".slide-up-scale").forEach((element) => {
      gsap.fromTo(
        element,
        {
          y: 50,
          opacity: 0,
          scale: 0.9,
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 1.3,
          ease: "power3.out",
          scrollTrigger: {
            trigger: element,
            start: "top 85%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    gsap.utils.toArray(".text-reveal-lines").forEach((element) => {
      const splitText = new SplitText(element, {
        type: "lines",
        linesClass: "line-reveal",
      });

      gsap.set(splitText.lines, {
        y: "100%",
        opacity: 0,
        transformOrigin: "0 50%",
      });

      gsap.to(splitText.lines, {
        y: "0%",
        opacity: 1,
        duration: 1.2,
        stagger: 0.15,
        ease: "power3.out",
        scrollTrigger: {
          trigger: element,
          start: "top 85%",
          toggleActions: "play none none reverse",
          onComplete: () => {
            splitText.revert();
          },
        },
      });
    });

    gsap.utils.toArray(".fade-in-stagger").forEach((container) => {
      const items = container.children;
      gsap.fromTo(
        items,
        {
          y: 40,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: container,
            start: "top 85%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    // Анімація для списків (li елементи або інші айтеми)
    gsap.utils.toArray(".list-reveal").forEach((list) => {
      const items = list.querySelectorAll("li, .list-item, .item");

      gsap.fromTo(
        items,
        {
          y: 50,
          opacity: 0,
          scale: 0.9,
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 1.2,
          stagger: 0.15,
          ease: "power3.out",
          scrollTrigger: {
            trigger: list,
            start: "top 85%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    // Анімація для списків (li елементи або інші айтеми)
    gsap.utils.toArray(".swiper-list-reveal").forEach((list) => {
      const items = list.querySelectorAll(".swiper-slide");

      gsap.fromTo(
        items,
        {
          y: 50,
          opacity: 0,
          scale: 0.9,
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          stagger: 0.15,
          ease: "power3.out",
          scrollTrigger: {
            trigger: list,
            start: "top 85%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    // Анімація карток/елементів у сітці
    gsap.utils.toArray(".grid-reveal").forEach((grid) => {
      const items = grid.children;

      gsap.fromTo(
        items,
        {
          y: 60,
          opacity: 0,
          rotationX: 45,
        },
        {
          y: 0,
          opacity: 1,
          rotationX: 0,
          duration: 1,
          stagger: {
            amount: 0.8,
            from: "start",
          },
          ease: "power2.out",
          scrollTrigger: {
            trigger: grid,
            start: "top 85%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    // Анімація для елементів що з'являються з лівого/правого боку
    gsap.utils.toArray(".slide-in-left").forEach((element) => {
      gsap.fromTo(
        element,
        {
          x: -100,
          opacity: 0,
        },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: element,
            start: "top 85%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    gsap.utils.toArray(".slide-in-right").forEach((element) => {
      gsap.fromTo(
        element,
        {
          x: 100,
          opacity: 0,
        },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: element,
            start: "top 85%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    console.log("GSAP ScrollTrigger initialized");
  } else {
    console.error("GSAP or ScrollTrigger not loaded");
  }
});
